export default "__VITE_ASSET__Ctbxtmmg__"